var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1248,
    height: 760,
    viewBox: "0 0 1248 760",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "A1_8",
    d: "M506.386 172.811L506.033 172.697L505.675 172.793L60.25 292.868V238.416L505.926 97.8341L726.258 195.317L726.733 244.275L506.386 172.811Z",
    fill: "#A0BA3B",
    fillOpacity: 0.47,
    stroke: "#A0BA3B",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "A1_7",
    d: "M506.373 236.807L506.056 236.708L505.731 236.779L60.25 334.945V292.959L505.968 173.303L726.75 244.411V273.771L676.892 257.313L676.583 257.211L676.264 257.272L611.573 269.713L506.373 236.807Z",
    fill: "#A0BA3B",
    fillOpacity: 0.47,
    stroke: "#A0BA3B",
    strokeWidth: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "A1_6",
    d: "M984.75 367.297L677.374 270.807L677.078 270.714L676.772 270.771L586.836 287.48L587.248 280.069L587.337 278.468L585.762 278.773L60.25 380.485V336.004L505.75 237.556V274.5V276.014L507.237 275.727L675.407 243.291L984.75 350.889V367.297Z",
    fill: "#A0BA3B",
    fillOpacity: 0.47,
    stroke: "#A0BA3B",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "A1_5",
    d: "M984.75 405.361L711.331 330.295L711.062 330.221L710.788 330.268L606.555 348.222L585.817 342.791L585.564 342.725L585.306 342.765L86.75 421.038V375.534L586.25 280.012V286.5V288.017L587.739 287.727L608.223 283.73L608.239 283.727L676.922 271.285L984.75 366.921V405.361Z",
    fill: "#A0BA3B",
    fillOpacity: 0.47,
    stroke: "#A0BA3B",
    strokeWidth: 2.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "A1_4",
    d: "M585.224 406.77L585.039 406.737L584.853 406.759L86.75 465.804V421.568L584.94 342.775L606.19 348.211L606.451 348.278L606.716 348.231L708.941 330.28L1019.25 414.955V461.467L709.252 397.776L709.048 397.734L708.842 397.76L607.034 410.736L585.224 406.77Z",
    fill: "#A0BA3B",
    fillOpacity: 0.47,
    stroke: "#A0BA3B",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "A1_3",
    d: "M585.75 474.34L86.75 511.653V465.611L584.961 406.763L606.776 410.73L606.967 410.764L607.159 410.74L708.448 397.767L1019.25 464.012V505.035L808.75 471.434V469.5V468.405L807.664 468.261L732.164 458.261L732.033 458.244L731.902 458.254L668.402 463.254L668.395 463.254L668.388 463.255L607.489 468.746L587.091 467.253L585.75 467.155V468.5V474.34Z",
    fill: "#A0BA3B",
    fillOpacity: 0.47,
    stroke: "#A0BA3B",
    strokeWidth: 2.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "A1_2",
    d: "M586.25 550.298L87.2393 569.701L86.7596 511.659L585.593 474.247L586.75 474.16V473V469.25H607.5H607.551L607.601 469.246L669.099 464.246L669.101 464.246L731.973 459.256L808.25 468.606V470.5V471.567L809.304 471.735L1019.23 505.064L1018.27 560.16L807.088 545.253L807.083 545.253L732.083 540.253L732.027 540.249L731.97 540.25L669 541.75H668.985H607.547L587.593 540.254L586.25 540.153V541.5V550.298Z",
    fill: "#A0BA3B",
    fillOpacity: 0.47,
    stroke: "#A0BA3B",
    strokeWidth: 2.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "A1_1",
    d: "M837.25 617V628.25H759H757.75V629.5V640.725L607.025 637.75L606.914 637.748L606.805 637.765L587.896 640.751L87.25 645.239V569.702L586.549 550.249L587.75 550.202V549V540.812L606.939 541.749L606.955 541.749L606.97 541.75L669.47 543.25L669.516 543.251L669.561 543.249L730.985 540.252L806.409 545.747L806.413 545.747L870.908 550.247L870.913 550.247L1018.21 561.158L1017.3 585.25H985H983.75V586.5V602.25H898H896.75V603.5V615.26L838.49 615.75L837.25 615.76V617Z",
    fill: "#A0BA3B",
    fillOpacity: 0.47,
    stroke: "#A0BA3B",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.45632857bc39cc0f426dfd089880c97a.svg";
export { ForwardRef as ReactComponent };